import React from "react";
import BulkUploadFile from "../../BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkPrizeItemUplaodActions from "../../../store/actions/BulkPrizeItemUpload";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const BulkPrizeItemUplaod = ({ getBulkUploadUrl, customHandleClose }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="BulkPrizeItemUploadBtn"
      uploadUrl="/prize-items/bulk/upload/ack"
      sampleURL="/sample/bulk_prize_items_upload.csv"
      id="BulkPrizeItemUploadModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Prize Item Upload"
      getUploadUrl={getBulkUploadUrl}
      customHandleClose={customHandleClose}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkPrizeItemUplaodActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkPrizeItemUplaod);
